<!-- <div style="margin-top: auto;">
    <router-outlet></router-outlet>
</div> -->

<div style ="margin-top: auto;"[ngClass]="{'content-with-margin': isLoggedIn()}">
    <router-outlet></router-outlet>
</div>